'use strict';
var template = require('./modal-close-header.html');

module.exports = [
  ModalCloseHeaderDirective];

function ModalCloseHeaderDirective() {
  return {
    restrict: 'E',
    template: template,
    scope: {
      header: '@',
      close: '&'
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/core-components-implementation/modals/ModalCloseHeaderDirective.js